import { styled } from '@mui/material/styles';
import { Box, Typography, Button, Modal, TextField } from '@mui/material';

// ============================================
// 관리자 변경 모달
// ============================================
export const SwitchModal = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

export const ModalContainer = styled(Box)({
  width: '480px',
  maxHeight: '80vh',
  backgroundColor: '#fff',
  borderRadius: '12px',
  outline: 'none',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
});

export const ModalHeader = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '16px 20px',
  backgroundColor: '#333',
  flexShrink: 0,
});

export const ModalTitle = styled(Typography)({
  fontSize: '16px',
  fontWeight: 600,
  color: '#fff',
});

export const CloseButton = styled(Box)({
  cursor: 'pointer',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
});

export const ModalBody = styled(Box)({
  flex: 1,
  overflowY: 'auto',
  padding: '8px 0',
});

// ============================================
// 직원 카드
// ============================================
export const EmployeeCard = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  padding: '12px 16px',
  borderBottom: '1px solid #f0f0f0',
  columnGap: '8px',
  '&:last-child': {
    borderBottom: 'none',
  },
});

export const EmployeeAvatar = styled(Box)({
  width: '48px !important',
  height: '48px !important',
  minWidth: '48px !important',
  borderRadius: '50%',
  backgroundColor: '#e0e0e0',
  overflow: 'hidden',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
});

export const EmployeeInfo = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const PositionName = styled(Typography)({
  fontSize: '13px',
  fontWeight: 600,
  color: '#0F7F85',
  lineHeight: 1.3,
});

export const EmployeeName = styled(Typography)({
  fontSize: '14px',
  color: '#333',
  lineHeight: 1.4,
});

export const LockIconWrapper = styled(Box)({
  color: '#bbb',
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  marginRight: '4px',
});

export const SelectButton = styled(Button)({
  minWidth: '72px',
  height: '36px',
  borderRadius: '8px',
  fontSize: '13px',
  fontWeight: 600,
  border: '1px solid #333',
  color: '#333',
  backgroundColor: '#fff',
  flexShrink: 0,
  '&:hover': {
    backgroundColor: '#f5f5f5',
    border: '1px solid #333',
  },
});

export const ActiveButton = styled(Button)({
  minWidth: '72px',
  height: '36px',
  borderRadius: '8px',
  fontSize: '13px',
  fontWeight: 600,
  backgroundColor: '#999',
  color: '#fff',
  flexShrink: 0,
  '&.Mui-disabled': {
    backgroundColor: '#999',
    color: '#fff',
  },
});

// ============================================
// 섹션 구분
// ============================================
export const SectionDivider = styled(Box)({
  padding: '10px 20px 6px',
  backgroundColor: '#f9f9f9',
  borderBottom: '1px solid #f0f0f0',
});

export const SectionLabel = styled(Typography)({
  fontSize: '12px',
  fontWeight: 600,
  color: '#888',
});

// ============================================
// 비밀번호 입력 모달
// ============================================
export const PasswordModalContainer = styled(Box)({
  width: '400px',
  backgroundColor: '#fff',
  borderRadius: '12px',
  outline: 'none',
  overflow: 'hidden',
});

export const PasswordModalBody = styled(Box)({
  padding: '24px 20px',
});

export const PasswordLabel = styled(Typography)({
  fontSize: '14px',
  fontWeight: 500,
  color: '#333',
  marginBottom: '8px',
});

export const PasswordInput = styled(TextField)({
  width: '100%',
  '& .MuiOutlinedInput-root': {
    borderRadius: '8px',
  },
});

export const PasswordModalFooter = styled(Box)({
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '8px',
  padding: '0 20px 20px',
});

// ============================================
// 헤더 전환 버튼
// ============================================
export const SwitchButton = styled(Button)({
  height: '36px',
  borderRadius: '8px',
  fontSize: '13px',
  fontWeight: 600,
  color: '#333',
  border: '1px solid #ddd',
  backgroundColor: '#fff',
  padding: '0 14px',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: '#f5f5f5',
    border: '1px solid #ccc',
  },
});

export const RestoreBanner = styled(Button)({
  height: '36px',
  borderRadius: '8px',
  fontSize: '12px',
  fontWeight: 600,
  color: '#fff',
  backgroundColor: '#0F7F85',
  padding: '0 12px',
  textTransform: 'none',
  whiteSpace: 'nowrap',
  '&:hover': {
    backgroundColor: '#0d6b70',
  },
});
